import { Card, Stack, Text, Center } from '@mantine/core';
import { IconHourglass } from '@tabler/icons-react';

const EmptyProcessCard = ({icon, title, description}) => (
  <Card radius="md" className='empty-process-card'>
    <Stack align="center" spacing="xs">
      <Center 
        style={{
            background: '#62626214',
            borderRadius: '50%',
            width: 64,
            height: 64,
            marginBottom: 8,
          }}
      >
        {icon}
      </Center>
      {title && (
        <Text size="lg" fw={600} c="#626262ff" ta="center">{title}</Text>
      )}
      <Text size="md" c="#626262ff" ta="center">{description}</Text>
    </Stack>
  </Card>
);

export default EmptyProcessCard;